import * as React from "react";
import { AppBar, AppBarProps, TitlePortal, useGetList, useRefresh, UserMenu, MenuItemLink, Logout  } from "react-admin";
import { Box, MenuItem, Select, IconButton, Badge, Tooltip } from "@mui/material";
import { useClub } from "../club/ClubContext";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom"; // <-- NEU
import PersonIcon from "@mui/icons-material/Person";
import MailIcon from "@mui/icons-material/Mail";
import { CustomUserMenu } from "./CustomUserMenu";
import { useInboxUnreadCount } from "../messages/useInboxUnreadCount";

function InboxHeaderButton({ clubId }: { clubId?: number | null }) {
  const navigate = useNavigate();
  const unread = useInboxUnreadCount(15000, clubId);

  return (
    <Tooltip title="Posteingang">
      <IconButton color="inherit" onClick={() => navigate("/inbox")}>
        <Badge badgeContent={unread} color="error" max={99}>
          <MailIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
}

type AssignableClub = { id: number; display_name: string };

const MyUserMenu = () => (
  <UserMenu>
    <MenuItemLink to="/profile" primaryText="Profil" leftIcon={<PersonIcon />} />
    <Logout />
  </UserMenu>
);

export function Menu(props: AppBarProps) {
  const { club, clubId, setClub } = useClub();
  const refresh = useRefresh();
  const queryClient = useQueryClient();
  const navigate = useNavigate(); // <-- NEU

  const { data, isLoading } = useGetList<AssignableClub>("users/assignable-clubs", {
    pagination: { page: 1, perPage: 1000 },
    sort: { field: "id", order: "ASC" },
    filter: {},
  });

  const clubs = data ?? [];
  React.useEffect(() => {
    if (!club && clubs.length > 0) {
      setClub(clubs[0]);
      queryClient.invalidateQueries();
      refresh();
    }
  }, [club, clubs, setClub, refresh, queryClient]);

  const handleChange = (e: any) => {
    const id = Number(e.target.value);
    const selected = clubs.find((c) => c.id === id);
    if (!selected) return;

    setClub(selected);

    queryClient.invalidateQueries();
    refresh();

    // ✅ nach Club-Wechsel immer Dashboard laden
    navigate("/", { replace: false });
  };

  return (
    <AppBar {...props} userMenu={<CustomUserMenu />}>


      <Box sx={{ display: "flex", alignItems: "center", gap: 1, ml: 1 }}>
        {/* ✅ nur anzeigen wenn es wirklich was zu wählen gibt */}
        {!isLoading && clubs.length > 1 && (
          <Select
            size="small"
            value={clubId ?? (clubs[0]?.id ?? "")}
            disabled={clubs.length === 0}
            onChange={handleChange}
            sx={{ minWidth: 140, width: 150 }}
          >
            {clubs.map((c) => (
              <MenuItem key={c.id} value={c.id}>
                {c.display_name}
              </MenuItem>
            ))}
          </Select>
        )}
      </Box>

      <Box sx={{ flex: 1 }} />

      <InboxHeaderButton clubId={clubId} />
    </AppBar>
  );
}
